import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['select', 'subject', 'message']

  fill() {
    const option = this.selectTarget.selectedOptions[0]
    if (!option) return

    if (this.hasSubjectTarget) this.subjectTarget.value = option.dataset.subject || ''

    if (this.hasMessageTarget) {
      this.messageTarget.value = option.dataset.message || ''
      // Let the autoSize controller grow the textarea back to the new content.
      this.messageTarget.dispatchEvent(new Event('focus'))
    }
  }
}
